import { render } from "./constraints.gatekeeper.sh.constraint.vue?vue&type=template&id=08ea0c61"
import script from "./constraints.gatekeeper.sh.constraint.vue?vue&type=script&lang=js"
export * from "./constraints.gatekeeper.sh.constraint.vue?vue&type=script&lang=js"

import exportComponent from "../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__